




import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import * as modules from '../../../store/decorator'

@Component
export default class VClientContact extends Vue {

    @Prop(String) label!: string
    @Prop() value!: any
    @Prop(Array) errorMessages!: Array <object>

    items: Array <string> = []
    result: any = []

    @Watch('value', { immediate: true })
    onValueChanged(newValue: any) {
        // Always update the result to match the new value, including empty arrays
        if (Array.isArray(newValue)) {
            this.result = [...newValue]; // Create a copy to avoid reference issues
        } else if (newValue) {
            this.result = [newValue]; // Convert single value to array
        } else {
            this.result = []; // Clear the selection when value is null/undefined
        }
    }

    mounted() {
        this.$http.get(`${ process.env.VUE_APP_DOT_NET_API_BASE_URL }${ process.env.VUE_APP_DOT_NET_API_CLIENT_CONTACTS }/${ modules.user.customerDetail.customerId }`)
        .then(response => {

            response.data.forEach((element: any) => {
                if (!element.soft_deleted) {
                    this.items.push(element.email);
                }
            })
        })
    }
}
